const removeInitialOverlay = () => {
  $('body').removeClass('initial-overlay');
}

const init = () => {
  setTimeout(() => {
    removeInitialOverlay();
  }, 300);
}

export default init;